import initialstate from '../initialstate';
import {
	GET_ALL_TASK_SECTIONS,
	REFRESH_TASK_IN_TASK_SECTIONS,
	DELETE_TASKSECTION_BY_ID,
	CREATE_TASK_SECTION,
	GET_TASK_SECTION_BY_ID,
	CLEAR_TASK_SECTION,
	UPDATE_TASK_SECTION
} from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
import {isApiResponseOk} from '../../util/utils';
import {cloneDeep, orderBy} from 'lodash';

export default function taskSectionReducer(state = initialstate.taskSections, action) {
	const deleteTaskSectionById = (taskSectionId) => {
		let newState = cloneDeep(state);
		newState = newState.filter((ts) => ts.taskSectionId != Number(taskSectionId));
		return newState;
	};

	const clearTaskSection = () => {
		let result = {...state};
		if (result.selectedTaskSection) {
			delete result.selectedTaskSection;
		}
		return Object.values(result);
	};

	switch (action.type) {
		case GET_ALL_TASK_SECTIONS:
			if (action.response) {
				return action.response || state;
			}
			break;
		case REFRESH_TASK_IN_TASK_SECTIONS:
			if (action.taskAttributes) {
				const task = action.taskAttributes;
				const taskSections = state;
				const taskSection = taskSections.find((section) => section.taskSectionId === task.taskSectionId);
				if (taskSection) {
					const updatedTasks = action.isForRemove
						? taskSection.relatedTasks.filter((relatedTask) => relatedTask.taskId !== task.taskId)
						: taskSection.relatedTasks.map((relatedTask) => (relatedTask.taskId === task.taskId ? task : relatedTask));
					return state.map((section) => {
						if (section.taskSectionId === task.taskSectionId) {
							return {
								...section,
								relatedTasks: updatedTasks
							};
						} else {
							return section;
						}
					});
				}
			}
			break;

		case DELETE_TASKSECTION_BY_ID:
			if (isApiResponseOk(action) || action.error?.response?.status === HttpStatusCodes.NotFound) {
				return deleteTaskSectionById(action.taskSectionId);
			}
			return state;

		case CREATE_TASK_SECTION:
			if (isApiResponseOk(action)) {
				let newState = cloneDeep(state);
				newState.push({...action.response, taskGroupSectionName: action.response.taskSectionName, isCustom: true});
				newState = orderBy(newState, ['taskGroupSectionName'], ['asc']);
				return newState;
			}
			return state;

		case GET_TASK_SECTION_BY_ID:
			if (isApiResponseOk(action)) {
				return {
					...state,
					selectedTaskSection: action.response
				};
			} else if (action?.error?.response.status === HttpStatusCodes.NotFound) {
				return deleteTaskSectionById(action.taskSectionId);
			}
			return state;

		case CLEAR_TASK_SECTION:
			return clearTaskSection();

		case UPDATE_TASK_SECTION:
			if (isApiResponseOk(action)) {
				let newState = clearTaskSection();
				const editIndex = newState?.findIndex((x) => x.taskSectionId === action.response.taskSectionId);
				const editStateData = {...newState[editIndex]};
				newState[editIndex] = {
					...editStateData,
					taskGroupSectionName: action.response.taskSectionName,
					auditPhaseId: action.response.auditPhaseId
				};
				newState = orderBy(newState, ['taskGroupSectionName'], ['asc']);
				return newState;
			}
			return state;

		default:
			return state;
	}
}
